import { connect } from 'react-redux';
import { toggleFeedbackPage, toggleBurgerMenuRequested, } from '../../redux/actions';
import { getIsFeedbackPageOpen } from '../../redux/selectors';
var mapStateToProps = function (state) { return ({
    isFeedbackPageOpen: getIsFeedbackPageOpen(state),
}); };
var mapDispatchToProps = {
    toggleFeedbackPage: toggleFeedbackPage,
    toggleBurgerMenu: toggleBurgerMenuRequested,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NotificationsDropdownWrapper.container.js.map